import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../MobileMenu/MobileMenu';
import Logo from '../../images/logo6.png';
import Practices from '../../api/Practices';
import Attorneys from '../../api/attorneys';

const Header = props => {
	const [menuActive, setMenuState] = useState(false);

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	const SubmitHandler = e => {
		e.preventDefault();
	};

	return (
		<header className=' relative z-[111]'>
			<div className='wpo-site-header bg-[#272c3f] relative '>
				<div className='wraper'>
					<div className='flex items-center justify-between '>
						<MobileMenu />

						<div className='logo w-[255px] md:w-[200px] md:mx-auto sm:w-[180px] col:w-[160px]'>
							<Link
								onClick={ClickHandler}
								className='text-[45px] col:text-[25px] font-bold flex items-center text-white'
								to='/'
							>
								<img className='w-full' src={Logo} alt='' />
							</Link>
						</div>
						<ul className='md:hidden mr-[-50px] lg-[-10px]'>
							<li className='relative inline-block group'>
								<Link
									onClick={ClickHandler}
									to='/'
									className='relative text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                                '
								>
									Accueil
								</Link>
							</li>
							<li className='relative inline-block group'>
								<Link
									onClick={ClickHandler}
									to='/equipe'
									className='relative group text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                              '
								>
									L'équipe
								</Link>
								<ul className='absolute w-[240px]  left-0 top-[110%] p-[20px] z-[111]  bg-[#fff] shadow-[#3e419f17]  transition-all  opacity-0 invisible group-hover:opacity-100  group-hover:top-full group-hover:visible'>
									{Attorneys.map((attorney, aitem) => (
										<li key={aitem}>
											<Link
												onClick={ClickHandler}
												to={'/equipe/' + attorney.slug}
												className='text-[15px] lg:text-[14px] inline-block py-[5px] uppercase text-[#333] group relative overflow-hidden font-normal transition-all hover:text-[#c0b596] 
											'
											>
												{attorney.name}
											</Link>
										</li>
									))}
								</ul>
							</li>
							<li className='relative inline-block group'>
								<Link
									onClick={ClickHandler}
									to='/matieres'
									className='relative group text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                              '
								>
									Matières
								</Link>
								<ul className='absolute w-[350px]  left-0 top-[110%] p-[20px] z-[111]  bg-[#fff] shadow-[0_4px_10px_#3e419f17]  transition-all  opacity-0 invisible group-hover:opacity-100  group-hover:top-full group-hover:visible'>
									<li>
										{Practices.map((practice, Pitem) => (
											<Link
												key={Pitem}
												onClick={ClickHandler}
												to={'/matieres/' + practice.slug}
												className='text-[15px] lg:text-[14px] pl-[15px] [text-indent:-15px] block py-[5px] uppercase text-[#333] group relative overflow-hidden font-normal transition-all hover:text-[#c0b596] 
                                        '
											>
												{practice.sTitle}
											</Link>
										))}
									</li>
								</ul>
							</li>
							<li className='relative inline-block group'>
								<Link
									onClick={ClickHandler}
									to='/honoraires'
									className='relative text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                                '
								>
									Honoraires
								</Link>
							</li>
							<li className='relative inline-block group'>
								<Link
									onClick={ClickHandler}
									to='/news'
									className='relative group text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                               '
								>
									Actualités
								</Link>
							</li>
							<li className='relative inline-block'>
								<Link
									onClick={ClickHandler}
									to='/contact'
									className='relative group text-[15px] lg:text-[14px] py-[35px] xl:py-[30px] px-[18px] xl:px-[6px] text-white block uppercase font-base-font font-normal hover:text-[#c0b596] transition-all
                               '
								>
									Contact
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
